import { notificationTexts } from "./notificationTexts";

/**
 * Translate a notification by type using the templates in notificationTexts
 * @param {string} type - one of notificationTexts keys (e.g., 'INVOICE_CREATED')
 * @param {object} payload - parameters to pass into the template (e.g., { invoiceNumber, patientName, creator })
 * @param {string} lang - language code ('en'|'fr'|'ar')
 * @returns {string} localized message or empty string when not found
 */


const titles = {
  en: {
    PATIENT_CREATED: "New Patient Created",
    INVOICE_CREATED: "New Invoice Created",
    APPOINTMENT_CREATED: "New Appointment Scheduled",
    WAITINGROOM_CREATED: "New Waiting Room Entry",
    PAYMENT_CREATED: "New Payment Recorded",
    VISIT_CREATED: "New Visit Logged",
    


    PATIENT_UPDATED: "Patient Information Updated",
    INVOICE_UPDATED: "Invoice Updated",
    APPOINTMENT_UPDATED: "Appointment Updated",
    WAITINGROOM_UPDATED: "Waiting Room Entry Updated",
    PAYMENT_UPDATED: "Payment Updated",
    VISIT_UPDATED: "Visit Updated",
    USER_PERMISSIONS_UPDATED: "User Permissions Updated",

    PATIENT_DELETED: "Patient Deleted",
    INVOICE_DELETED: "Invoice Deleted",
    APPOINTMENT_DELETED: "Appointment Deleted",
    WAITINGROOM_DELETED: "Waiting Room Entry Deleted",
    PAYMENT_DELETED: "Payment Deleted",
    VISIT_DELETED: "Visit Deleted",
  },  fr: {
    PATIENT_CREATED: "Nouveau patient créé",
    INVOICE_CREATED: "Nouvelle facture créée",
    APPOINTMENT_CREATED: "Nouveau rendez-vous programmé",
    WAITINGROOM_CREATED: "Nouvelle entrée en salle d'attente",
    PAYMENT_CREATED: "Nouveau paiement enregistré",
    VISIT_CREATED: "Nouvelle visite enregistrée",
    PATIENT_UPDATED: "Informations sur le patient mises à jour",
    INVOICE_UPDATED: "Facture mise à jour",
    APPOINTMENT_UPDATED: "Rendez-vous mis à jour",
    WAITINGROOM_UPDATED: "Entrée en salle d'attente mise à jour",
    PAYMENT_UPDATED: "Paiement mis à jour",
    VISIT_UPDATED: "Visite mise à jour",
    USER_PERMISSIONS_UPDATED: "Autorisations utilisateur mises à jour",
    PATIENT_DELETED: "Patient supprimé",
    INVOICE_DELETED: "Facture supprimée",
    APPOINTMENT_DELETED: "Rendez-vous supprimé",
    WAITINGROOM_DELETED: "Entrée en salle d'attente supprimée",
    PAYMENT_DELETED: "Paiement supprimé",
    VISIT_DELETED: "Visite supprimée",
    },  ar: {
    PATIENT_CREATED: "تم إنشاء مريض جديد",
    INVOICE_CREATED: "تم إنشاء فاتورة جديدة",
    APPOINTMENT_CREATED: "تم تحديد موعد جديد",
    WAITINGROOM_CREATED: "تم إنشاء إدخال جديد في غرفة الانتظار",
    PAYMENT_CREATED: "تم تسجيل دفعة جديدة",
    VISIT_CREATED: "تم تسجيل زيارة جديدة",
    PATIENT_UPDATED: "تم تحديث معلومات المريض",
    INVOICE_UPDATED: "تم تحديث الفاتورة",
    APPOINTMENT_UPDATED: "تم تحديث الموعد",
    WAITINGROOM_UPDATED: "تم تحديث إدخال غرفة الانتظار",
    PAYMENT_UPDATED: "تم تحديث الدفعة",
    VISIT_UPDATED: "تم تحديث الزيارة", 
    USER_PERMISSIONS_UPDATED: "تم تحديث أذونات المستخدم",
    PATIENT_DELETED: "تم حذف المريض",
    INVOICE_DELETED: "تم حذف الفاتورة",
    APPOINTMENT_DELETED: "تم حذف الموعد",
    WAITINGROOM_DELETED: "تم حذف إدخال غرفة الانتظار",
    PAYMENT_DELETED: "تم حذف الدفعة",
    VISIT_DELETED: "تم حذف الزيارة",
  }
};
    
export function notificationTranslator(key, payload = {}, lang = "en") {
  if (!key) return { title: '', message: '' };
  const templates = notificationTexts[key];

  // Determine title from titles map (fallback to English or empty)
  const titleLang = (titles[lang] && titles[lang][key]) ? lang : 'en';
  const title = (titles[titleLang] && titles[titleLang][key]) || (titles.en && titles.en[key]) || '';

  // Compute message from templates
  let message = '';
  if (templates) {
    const language = templates[lang] ? lang : 'en';
    const template = templates[language] || templates.en;

    try {
      message = typeof template === 'function' ? template(payload) : String(template);
    } catch (err) {
      try {
        const fallback = templates.en;
        message = typeof fallback === 'function' ? fallback(payload) : String(fallback);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('notificationTranslator error:', err, e);
        message = '';
      }
    }
  }

  return { title, message };
}

export default notificationTranslator;
